export default {
    "Year": "2023",
    "Company Name": "苏州指薪趣品服务外包有限公司",
    "ICP": "苏ICP备20031329号-1",
    "Product Name": "成语词典大全",
    "Pic": [
        require("@/assets/1080x1920/1.png"),
        require("@/assets/1080x1920/2.png"),
        require("@/assets/1080x1920/3.png"),
        require("@/assets/1080x1920/4.png"),
        require("@/assets/1080x1920/5.png")
    ],
    "Mail address": "苏州市吴中区木渎镇汇润国际商业广场1幢2108室",
    "Phone": "17751262870",
}